import type { FC, ReactNode } from "react";
import {
  Box,
  Card,
  Divider,
  Group,
  ThemeIcon,
  Title,
  type MantineColor,
} from "@mantine/core";
import type { Icon } from "@tabler/icons-react";
import { ICON_STROKE } from "./order-page-v2.utils";

type OrderDetailCardProps = {
  icon: Icon;
  iconColor?: MantineColor;
  title: string;
  rightSection?: ReactNode;
  children: ReactNode;
};

export const OrderDetailCard: FC<OrderDetailCardProps> = ({
  icon: CardIcon,
  iconColor = "brand",
  title,
  rightSection,
  children,
}) => (
  <Card withBorder p={0}>
    <Group justify="space-between" wrap="nowrap" gap="s3" px="s5" py="s4">
      <Group gap="s3" wrap="nowrap">
        <ThemeIcon variant="light" color={iconColor} size="md" radius="sm">
          <CardIcon size={16} stroke={ICON_STROKE} />
        </ThemeIcon>
        <Title order={4}>{title}</Title>
      </Group>
      {rightSection}
    </Group>
    <Divider color="ink.0" />
    <Box p="s5">{children}</Box>
  </Card>
);
